<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item && item.id ? 'Update' : 'Submit'"
    :submit-btn-disabled="(!item.id || item.id <= 0) && item.commercial_skid_items.length < 1"
    :is-submit-btn="!isViewing"
    :full-screen="true"
    :persistent="true"
  >
    <template slot="header">
      <span
        >{{ headlineText() }} Skid
        {{ item.skid_number ? `#${item.skid_number}` : '' }}</span
      >
    </template>
    <template slot="body">
      <v-row>
        <v-col v-if="item && item.status" class="text-center">
          <h3 class="h3">Status</h3>
          <v-chip
            medium
            :color="item && item.status ? item.status.color : 'black'"
            text-color="white"
            class="mt-1"
          >
            {{ item && item.status ? item.status.name : '' }}
          </v-chip>
        </v-col>
        <v-col v-if="item && item.commercial_bill_of_lading_item && item.commercial_bill_of_lading_item.bill_of_lading && item.commercial_bill_of_lading_item.bill_of_lading.code" class="text-center">
          <h3 class="h3">Bill Of Lading Code</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.commercial_bill_of_lading_item.bill_of_lading.code : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.created_at" class="text-center">
          <h3 class="h3">Created At</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.created_at : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.created_by_name" class="text-center">
          <h3 class="h3">Created By</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.created_by_name : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.shipped_at" class="text-center">
          <h3 class="h3">Shipped Date</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.shipped_at : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.shipped_by_name" class="text-center">
          <h3 class="h3">Shipped By</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.shipped_by_name : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.received_at" class="text-center">
          <h3 class="h3">Received Date</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.received_at : ''
          }}</span>
        </v-col>
        <v-col v-if="item && item.received_by_name" class="text-center">
          <h3 class="h3">Received By</h3>
          <span class="mt-1 font-weight-bold">{{
            item ? item.received_by_name : ''
          }}</span>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="3" class="mt-4 pb-0">
          <v-text-field
            v-model="tagQr"
            autofocus
            :disabled="isViewing"
            @keydown.enter.native.prevent
            @input="qrCodeValueChange"
          />
        </v-col>
        <v-col cols="auto" class="mt-4 pb-0">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <div v-on="!tagQr ? on : ''">
                <v-btn
                  v-bind="attrs"
                  color="primary"
                  outlined
                  :disabled="!tagQr || isViewing"
                  @click="handleTagScan"
                  @keyup.enter="handleTagScan"
                >
                  Scan
                </v-btn>
              </div>
            </template>
            <span> Add Bundle or Finished Good Tag</span>
          </v-tooltip>
        </v-col>
        <v-spacer />
        <!-- <v-col class="mt-4 pb-0" cols="auto">
          <span style="font-size: 60px; font-weight: bold; color: #000"
            >Total Item QTY:
            {{
              item && item.commercial_skid_items
                ? item.commercial_skid_items.length
                : 0
            }}</span
          >
        </v-col> -->
        <v-col class="mt-4 pb-0" cols="auto">
          <span style="font-size: 60px; font-weight: bold; color: #000"
            >Total Bundle QTY:
            {{ getTotalBundleQuantity() }}
          </span>
        </v-col>
        <v-col class="mt-4 pb-0" cols="auto">
          <span style="font-size: 60px; font-weight: bold; color: #000"
            >Total Finished Good QTY:
            {{ getTotalFinishedGoodQuantity() }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-0">
          <v-card elevation="0" outlined>
            <v-data-table
              :headers="headers"
              :items="item.commercial_skid_items"
              hide-default-footer
              :items-per-page="-1"
              :loading="loading"
              :height="tableHeight"
              show-expand
              :expanded.sync="expandedItems"
              item-key="temp_id"
              dense
              :item-class="getTopLevelRowClass"
            >
              <template #[`item.data-table-expand`]="{ item }">
                <tr>
                  <td>
                    <v-icon
                      style="font-size: 22px !important"
                      @click="toggleExpand(item)"
                    >
                      {{
                        isRowExpanded(item)
                          ? 'mdi-chevron-down'
                          : 'mdi-chevron-up'
                      }}
                    </v-icon>
                  </td>
                </tr>
              </template>
              <template #[`item.type`]="{ item }">
                {{ getType(item) }}
              </template>
              <template #[`item.number_or_tag`]="{ item }">
                {{ getNumberOrTag(item) }}
              </template>
              <template #[`item.quantity`]="{ item }">
                {{ getQuantity(item) }}
              </template>
              <template #[`item.weight`]="{ item }">
                {{ getSkidItemWeight(item) }}
              </template>
              <template #[`item.actions`]="{ item }">
                <v-btn
                  v-if="!isViewing && showTopLevelRemoveButton(item)"
                  class="ml-1 mt-1 mb-1"
                  color="error"
                  outlined
                  small
                  @click="removeItem(item)"
                >
                  REMOVE
                </v-btn>
              </template>
              <template #expanded-item="{ headers, item }">
                <td class="px-2 py-2" :colspan="headers.length">
                  <v-data-table
                    id="sub-table"
                    :headers="subHeaders"
                    :items="getFinishedGoodOrBundleFinishedGoods(item)"
                    hide-default-footer
                    :items-per-page="-1"
                    dense
                    :item-class="getFinishedGoodRowClass"
                  >
                    <template
                      v-for="h in subHeaders"
                      #[`header.${h.value}`]="{ header }"
                    >
                      <v-tooltip v-if="h.fullText" :key="h.value" top>
                        <template #activator="{ on }">
                          <span v-on="on">{{ header.text }}</span>
                        </template>
                        <span>{{ header.fullText }}</span>
                      </v-tooltip>
                      <span v-else :key="h.value">
                        {{ h.text }}
                      </span>
                    </template>
                    <template #[`item.finished_good.tag_id`]="{ item }">
                      <span style="font-weight: bold">
                        {{
                          getFinishedGoodTagId(item)
                        }}
                      </span>
                    </template>
                    <template #[`item.finished_good.tag_number`]="{ item }">
                      <span style="font-weight: bold">
                        {{
                          getFinishedGoodTagNumber(item)
                        }}
                      </span>
                    </template>
                    <template #[`item.finished_good.sequence_number`]="{ item }">
                      {{
                        getFinishedGoodSequenceNumber(item)
                      }}
                    </template>
                    <template #[`item.status`]="{ item }">
                      <v-chip
                        v-if="hasFinishedGoodStatus(item)"
                        small
                        :color="getFinishedGoodStatusColor(item)"
                        text-color="white"
                      >
                        {{ getFinishedGoodStatusName(item) }}
                      </v-chip>
                    </template>
                    <template #[`item.finished_good.type.name`]="{ item }">
                      {{ getFinishedGoodTypeName(item) }}
                    </template>
                    <template #[`item.finished_good.aluminum_die.code`]="{ item }">
                      {{ getFinishedGoodAluminumDieCode(item) }}
                    </template>
                    <template #[`item.finished_good.int_color.code`]="{ item }">
                      {{ getFinishedGoodIntColorCode(item) }}
                    </template>
                    <template #[`item.finished_good.ext_color.code`]="{ item }">
                      {{ getFinishedGoodExtColorCode(item) }}
                    </template>
                    <template #[`item.finished_good.length`]="{ item }">
                      {{ getFinishedGoodLength(item) }}
                    </template>
                    <template #[`item.finished_good.weight`]="{ item }">
                      <span
                        v-if="getWeightKilograms(item)"
                      >
                        {{ getFinishedGoodWeight(item) }}
                      </span>
                      <span v-else>
                        <v-tooltip left>
                          <template #activator="{ on }">
                            <span
                              style="color: red; font-weight: bold"
                              v-on="on"
                              >!</span
                            >
                          </template>
                          <span> Missing {{ getFinishedGoodMissingField(item) }}; Unable to calculate weight </span>
                        </v-tooltip>
                      </span>
                    </template>
                    <template #[`item.actions`]="{ item }">
                      <v-btn
                        v-if="!isViewing && showFinishedGoodRemoveButton(item)"
                        class="ml-1 mt-1 mb-1"
                        color="error"
                        outlined
                        small
                        @click="removeFinishedGoodFromGroup(item)"
                      >
                        REMOVE
                      </v-btn>
                    </template>
                    <template slot="body.append" v-if="item.commercial_bundle">
                      <tr>
                        <th />
                        <th />
                        <th />
                        <th />
                        <th />
                        <th />
                        <th class="text-end pr-1">
                          <span
                            style="
                              color: #000000;
                              font-weight: bold;
                              font-size: 14px;
                            "
                            >Totals:
                          </span>
                        </th>
                        <!-- <th class="text-end">
                          <span style="font-weight: bold; font-size: 14px"
                            >{{
                              parseFloat(getTotalSqft(getFinishedGoodOrBundleFinishedGoods(item))).toLocaleString(
                                'en-US',
                                { maximumFractionDigits: 2 }
                              )
                            }}
                            sqft</span
                          >
                        </th>
                        <th class="text-end">
                          <span style="font-weight: bold; font-size: 14px">{{
                            displayInchesWithFraction(getTotalWidth(getFinishedGoodOrBundleFinishedGoods(item)))
                          }}</span>
                        </th>
                        <th class="text-end">
                          <span style="font-weight: bold; font-size: 14px">{{
                            displayInchesWithFraction(getTotalHeight(getFinishedGoodOrBundleFinishedGoods(item)))
                          }}</span>
                        </th> -->
                        <th class="text-end">
                          <span style="font-weight: bold; font-size: 14px">{{
                            displayInchesWithFraction(getTotalLength(getFinishedGoodOrBundleFinishedGoods(item)))
                          }}</span>
                        </th>
                        <th class="text-end">
                          <span style="font-weight: bold; font-size: 14px">{{
                            parseFloat(
                              getTotalWeightKilograms(getFinishedGoodOrBundleFinishedGoods(item))
                            ).toLocaleString('en-US', {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 2,
                            })
                          }}</span>
                        </th>
                        <th />
                        <th />
                      </tr>
                    </template>
                  </v-data-table>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="3"
          class="pl-8"
        >
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-briefcase-variant</v-icon>
            <span
              :style="{
              color: isDarkMode ? '' : '#000000',
              fontSize: '18px',
              }">{{ formattedJob }}</span>
          </div>
        </v-col>
        <v-spacer />
        <v-col cols="auto" class="pb-0 pt-0">
          <v-row align="center">
            <v-col class="pr-2 pt-6">
              <span
                :style="{
                  color: isDarkMode ? '#ffffffb3' : '#00000099',
                  fontSize: '16px !important',
                }"
                >Decimal</span
              >
            </v-col>
            <v-col class="pl-0">
              <v-switch
                v-model="uomSwitch"
                hide-details
                class="mt-0 pt-3"
                label="Fraction"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="auto" class="text-end pr-10">
          <span
            :style="{
              color: isDarkMode ? '' : '#000000',
              fontWeight: 'bold',
              fontSize: '18px',
            }"
            >Total Item Qty: {{ item && item.commercial_skid_items ? item.commercial_skid_items.length : 0 }}</span
          >
        </v-col>
      </v-row>
      <confirm-form ref="confirmForm" />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as FormatHelpers from '@/helpers/FormatHelpers';

export default {
  components: {},
  props: {},
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      commercial_skid_id: null,
      commercial_skid_items: [],
      job_id: null,
    },
    tagQr: null,
    commercialSkidItems: [],

    headers: [
      { text: 'Type', value: 'type', width: '10%', sortable: false },
      { text: 'Number', value: 'number_or_tag', width: '10%', sortable: false },
      { text: 'Qty', value: 'quantity', align: 'center', width: '5%', sortable: false },
      {
        text: 'Weight (kg)',
        value: 'weight',
        align: 'end',
        width: '10%',
        sortable: false,
      },
      { text: 'Actions', value: 'actions', align: 'end', width: '65%', sortable: false },
    ],

    subHeaders: [
      { text: 'Tag ID', value: 'finished_good.tag_id', sortable: false, width: '15%' },
      {
        text: 'Tag #',
        fullText: 'Window Number on Drawing',
        value: 'finished_good.tag_number',
        sortable: false,
        width: '10%',
      },
      {
        text: 'Sequence #',
        value: 'finished_good.sequence_number',
        sortable: false,
        width: '5%',
      },
      // {
      //   text: 'Work Order',
      //   value: 'finished_good.work_order',
      //   sortable: false,
      // },
      // {
      //   text: 'Reference',
      //   value: 'finished_good.floor_number',
      //   sortable: false,
      // },
      {
        text: 'Type',
        value: 'finished_good.type.name',
        width: '5%',
        sortable: false,
      },
      {
        text: 'Die',
        value: 'finished_good.aluminum_die.code',
        width: '5%',
        sortable: false,
      },
      {
        text: 'Int. Color',
        value: 'finished_good.int_color.code',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Ext. Color',
        value: 'finished_good.ext_color.code',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Length (inches)',
        value: 'finished_good.length',
        align: 'end',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Weight (kg)',
        value: 'finished_good.weight',
        align: 'end',
        width: '10%',
        sortable: false,
      },
      {
        text: 'Status',
        value: 'status',
        align: 'center',
        sortable: false,
        width: '10%',
      },
      {
        text: 'Actions',
        value: 'actions',
        align: 'end',
        sortable: false,
        width: '10%',
      },
    ],
    tableHeight: 570,
    topSpaceHeight: 470,
    expandedItems: [],

    isStreamlineDoorScanning: false,
    loading: false,
    uomSwitch: true,
    timeoutId: null,
    isViewing: false,
    isCommercialSkidQr: false,
    tagsToReassignFromOtherBundles: [],
    tagsToReassignFromOtherSkids: [],
    bundlesToReassignFromOtherSkids: [],
    finishedGoodCommercialTypeIdWindow: 1,
    finishedGoodCommercialTypeIdDoor: 2,
    finishedGoodCommercialTypeIdFrame: 3,
    finishedGoodCommercialTypeIdSlab: 4,
    productionScheduleStatusIdInProgress: 1,
    jobSubClassIdCommDoor: 7,
  }),
  computed: {
    ...mapState({
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),
    formattedJob() {
      if (!this.item?.job) return 'No Assigned Job';

      const { code, name, reference } = this.item.job;
      return `${code} - ${name}${reference ? `; ${reference}` : ''}`;
    },
  },
  created() {
    this.item = { ...this.itemDto };
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
    this.updateTableHeight();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    async init() {
      this.isStreamlineDoorScanning = this.businessRulesGetBoolean('Streamline Door Scanning');
    },

    async open(id = null, isViewing = false, tagQr = null, isCommercialSkidQr = false) {
      this.$bus.$emit('loading');
      this.isViewing = isViewing;
      this.isCommercialSkidQr = isCommercialSkidQr;
      this.finishedGoodsToReassignFromOtherBundles = [];
      this.finishedGoodsToReassignFromOtherSkids = [];
      this.bundlesToReassignFromOtherSkids = [];
      // if (this.isCommercialSkidQr) {
      //   id = this.extractIdFromQrCode(id);
      //   if (!id) {
      //     this.$refs.dialogBox.close();
      //     this.$bus.$emit('loading-stop');
      //     this.$bus.$emit('showError', 'QR code is incorrect');
      //     return;
      //   }
      // }
      if (id) {
        const request = {
          id,
        };
        await this.get(request);
      }
      else if (tagQr) {
        const request = {
          bundle_number: tagQr,
        };
        await this.get(request);
      } else {
        this.item = JSON.parse(JSON.stringify(this.itemDto));
      }
      await this.$refs.dialogBox.open(); // for some reason need to add await, otherwise user's location won't be set in v-autocomplete by default
      this.$bus.$emit('loading');
    },

    async get(requestData) {
      const submitModel = {
        filters: requestData,
      };
      const res = await this.$api.commercialSkid.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || res.length === 0) {
        this.$bus.$emit('showError', 'Skid not found');
        return;
      }
      const firstIndex = 0;
      this.item = res.data[firstIndex];

      this.item.commercial_skid_items = this.groupTopLevelFinishedGoods(
        this.item.commercial_skid_items
      );
    },

    async submit() {
      this.$bus.$emit('loading');
      let res = false;

      if (this.finishedGoodsToReassignFromOtherBundles.length > 0) {
        this.item.finished_goods_to_reassign_from_other_bundles = this.finishedGoodsToReassignFromOtherBundles;
      }

      if (this.finishedGoodsToReassignFromOtherSkids.length > 0) {
        this.item.finished_goods_to_reassign_from_other_skids = this.finishedGoodsToReassignFromOtherSkids;
      }

      if (this.bundlesToReassignFromOtherSkids.length > 0) {
        this.item.bundles_to_reassign_from_other_skids = this.bundlesToReassignFromOtherSkids;
      }

      const submitItem = {
        ...this.item,
        commercial_skid_items: this.flattenCommercialSkidItems(),
      };

      if (this.item.id) {
        res = await this.$api.commercialSkid.update(submitItem);
      } else {
        res = await this.$api.commercialSkid.store(submitItem);
      }
      if (!res) {
        this.$bus.$emit('loading');
        this.$bus.$emit('showError');
        return false;
      }
      this.$bus.$emit('loading');
      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return true;
    },

    async handleTagScan() {
        // need to check if tag is bundle or finished good then call appropriate function
        // bundle qr code format - BN[number]
        // so just check if it starts with BN and the rest is a number and nothing else
        const inputType = this.getInputType(this.tagQr);
        if (inputType === 'bundle') {
          this.addBundle();
        } else if (inputType === 'finished_good') {
          this.addTag();
        } else {
          this.$bus.$emit('showError', 'Invalid QR code');
          this.tagQr = null;
        }
    },

    getInputType(value) {
      if (!value || typeof value !== 'string') return 'invalid';

      const trimmed = value.trim();

      const isBundle = /^BN\d+$/.test(trimmed);
      if (isBundle) return 'bundle';

      const isFinishedGood = /^[A-Za-z0-9.-]+$/.test(trimmed);
      if (isFinishedGood) return 'finished_good';

      return 'invalid';
    },

    async addBundle() {
      this.$bus.$emit('loading');

      // Validation checks:
      // Already scanned (bundle already on this skid) → block
      // Same job validation (same rule as FG; first scan sets job)
      // If bundle is on another skid → prompt to move
      // If bundle is already assigned to a Bill Of Lading → block

      // If bundle contains FGs assigned to a bill of lading → block (not sure if needed since we are already blocking when FGs are added to bundles)
      // If bundle contains invalid FG statuses (Shipped, Received, Quarantined) → block (not sure if needed since we are already blocking when FGs are added to bundles)

      let bundleToReassignFromOtherSkid = null;

      const submitModel = {
        filters: {
          bundle_number: this.tagQr,
        },
      };
      const res = await this.$api.commercialBundle.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Bundle is not found or incorrect', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      const bundle = res.data[0];
      if (this.isBundleScanned(bundle)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Bundle has already been scanned', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      const isBundleSameJobData = this.isBundleSameJob(bundle);
      if (!isBundleSameJobData.is_same_job) {
        const firstItemJobName = isBundleSameJobData.first_item_job_name ? isBundleSameJobData.first_item_job_name : 'N/A';
        const addedItemJobName = isBundleSameJobData.added_item_job_name ? isBundleSameJobData.added_item_job_name : 'N/A'; 
        const errorMessage = `Bundle is from a different job (${firstItemJobName} vs ${addedItemJobName})`;
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', errorMessage, null, 'xl', 5000);
        this.tagQr = null;
        return;
      }

      const skidNumber = await this.isBundleAssignedToSkid(bundle);
      if (skidNumber === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if bundle is assigned to a skid', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (skidNumber) {
        this.$bus.$emit('loading-stop');
        const confirm = await this.$refs.confirmForm.open({
          title: `Bundle is under - Skid #${skidNumber} - Would you like to move it?`,
        });
        if (!confirm) {
          this.tagQr = null;
          return;
        }
        bundleToReassignFromOtherSkid = bundle;
      }

      const billOfLadingId = await this.isBundleAssignedToBillOfLading(bundle);
      if (billOfLadingId === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if bundle is assigned to a bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (billOfLadingId) {
        this.$bus.$emit('loading-stop');  
        this.$bus.$emit('showError', `Bundle is under - Bill Of Lading #${billOfLadingId}`, null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      if (bundleToReassignFromOtherSkid) {
        this.bundlesToReassignFromOtherSkids.push(bundleToReassignFromOtherSkid);
      }

      this.item.commercial_skid_items.unshift({ commercial_bundle: bundle, temp_id: Date.now(), });

      this.expandedItems.push(this.item.commercial_skid_items[0]);

      if (this.item.job_id === null) {
        const jobId = bundle.job_id ? bundle.job_id : null;
        const job = bundle.job ? bundle.job : null;
        this.$set(this.item, 'job_id', jobId);
        this.$set(this.item, 'job', job);
      }

      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess', null, null, 2500);
      this.tagQr = null;
    },

    async addTag() {
      this.$bus.$emit('loading');

      // Validation checks:
      // Already scanned (directly on skid OR indirectly via bundle)
      // Same job validation (except first scan sets the job)
      // Check full container chain (FG → bundle → skid) 
      //  - If in another bundle → prompt to move
      //  - If directly in another skid → prompt to move
      //  - If in a bundle on another skid → prompt to move (with correct context)
      // If assigned to a bill of lading → block
      // Commercial schedule must be “IN PROGRESS” → else block
      // Invalid FG statuses (Shipped, Received, Quarantined) → block
      // Invalid FG type (Door) → block

      let finishedGoodToReassignFromOtherBundle = null;
      let finishedGoodToReassignFromOtherSkid = null;

      const submitModel = {
        filters: {
          tag_id: this.tagQr,
        },
      };
      const res = await this.$api.finishedGoodCommercial.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || res.length === 0) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag is not found or incorrect', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      const finishedGood = res[0];
      if (this.isScanned(finishedGood)) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has already been scanned', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdWindow) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag is a window - unable to add to skid', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdDoor) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag is a door - unable to add to skid', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      if (this.isDoorComponent(finishedGood) && this.isStreamlineDoorScanning) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag is a door component - unable to add to skid while Streamline Door Scanning is enabled', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      const isFinishedGoodSameJobData = this.isFinishedGoodSameJob(finishedGood);
      if (!isFinishedGoodSameJobData.is_same_job) {
        // const firstItemJobName = isFinishedGoodSameJobData.first_item_job_name ? isFinishedGoodSameJobData.first_item_job_name : 'N/A';
        // const addedItemJobName = isFinishedGoodSameJobData.added_item_job_name ? isFinishedGoodSameJobData.added_item_job_name : 'N/A'; 
        // const errorMessage = `Tag is from a different job (${firstItemJobName} vs ${addedItemJobName})`;
        const errorMessage = 'Tag is from a different job';
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', errorMessage, null, 'xl', 5000);
        this.tagQr = null;
        return;
      }

      const bundleNumber = await this.isTagAssignedToBundle(finishedGood);
      if (bundleNumber === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if tag is assigned to another bundle', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (bundleNumber) {
        // this.$bus.$emit('loading-stop');
        // this.$bus.$emit('showError', `Window is under - Bundle #${bundleNumber}`, null, 'xl', 2500);
        // this.tagQr = null;
        // return;
        this.$bus.$emit('loading-stop');
        const confirm = await this.$refs.confirmForm.open({
          title: `Tag is under - Bundle #${bundleNumber} - Would you like to move it?`,
        });
        if (!confirm) {
          this.tagQr = null;
          return;
        }
        finishedGoodToReassignFromOtherBundle = finishedGood;
      }
      const skidNumber = await this.isTagAssignedToSkid(finishedGood);
      if (skidNumber === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if tag is assigned to a skid', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (skidNumber) {
        this.$bus.$emit('loading-stop');
        const confirm = await this.$refs.confirmForm.open({
          title: `Tag is under - Skid #${skidNumber} - Would you like to move it?`,
        });
        if (!confirm) {
          this.tagQr = null;
          return;
        }
        finishedGoodToReassignFromOtherSkid = finishedGood;
      }
      const billOfLadingId = await this.isTagAssignedToBillOfLading(finishedGood);
      if (billOfLadingId === undefined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error determining if tag is assigned to a bill of lading', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (billOfLadingId) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', `Tag is under - Bill Of Lading #${billOfLadingId}`, null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      // if (finishedGood.commercial_schedule == null || finishedGood.commercial_schedule == undefined) {
      //   this.$bus.$emit('loading-stop');
      //   this.$bus.$emit('showError', 'Finished Good is not part of a commercial schedule', null, 'xl', 2500);
      //   this.tagQr = null;
      //   return;
      // }
      if (finishedGood.commercial_schedule && finishedGood.commercial_schedule.status_id !== this.productionScheduleStatusIdInProgress) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Finished Good\'s Curtainwall Schedule status is not set to In Progress (Current)', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (finishedGood.status_id === this.finishedGoodStatusIdShipped) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has already been shipped', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (finishedGood.status_id === this.finishedGoodStatusIdReceived) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has already been received', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (finishedGood.status_id === this.finishedGoodStatusIdQuarantined) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Tag has been quarantined', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }
      if (!finishedGood.type) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Finished good type is not set - unable to calculate weight', null, 'xl', 2500);
        this.tagQr = null;
        return;
      }

      if (finishedGoodToReassignFromOtherBundle) {
        this.finishedGoodsToReassignFromOtherBundles.push(finishedGoodToReassignFromOtherBundle);
      }
      if (finishedGoodToReassignFromOtherSkid) {
        this.finishedGoodsToReassignFromOtherSkids.push(finishedGoodToReassignFromOtherSkid);
      }

      const existingFinishedGoodGroup = this.getTopLevelFinishedGoodGroup();

      if (existingFinishedGoodGroup) {
        existingFinishedGoodGroup.finished_goods.push(finishedGood);
        this.expandRow(existingFinishedGoodGroup);
      } else {
        const newGroup = {
          type: 'finished_good_group',
          tag_number: '',
          finished_goods: [finishedGood],
          temp_id: 'top-level-finished-goods',
        };

        this.item.commercial_skid_items.unshift(newGroup);
        this.expandRow(newGroup);
      }

      if (this.item.job_id === null) {
        const jobId = finishedGood.commercial_schedule && finishedGood.commercial_schedule.job_id
          ? finishedGood.commercial_schedule.job_id
          : null;

        const job = finishedGood.commercial_schedule && finishedGood.commercial_schedule.job
          ? finishedGood.commercial_schedule.job
          : null;

        this.$set(this.item, 'job_id', jobId);
        this.$set(this.item, 'job', job);
      }

      this.$bus.$emit('loading-stop');
      this.$bus.$emit('showSuccess', null, null, 2500);
      this.tagQr = null;
    },

    isScanned(finishedGood) {
      return this.item.commercial_skid_items.some(
        (x) => {
          if (x.type === 'finished_good_group') {
            return x.finished_goods.some((fg) => fg.id === finishedGood.id);
          }

          if (x.finished_good?.id === finishedGood.id) {
            return true;
          }

          if (x.commercial_bundle && x.commercial_bundle.commercial_bundle_items) {
            return x.commercial_bundle.commercial_bundle_items.some(
              (bundleItem) => bundleItem.finished_good?.id === finishedGood.id
            );
          }

          return false;
        }
      );
    },

    isDoorComponent(finishedGood) {
      const subClassId = finishedGood?.commercial_schedule?.job?.sub_class_id;
      return subClassId === this.jobSubClassIdCommDoor;
    },

    isBundleScanned(bundle) {
    //   const index = this.item.commercial_skid_items.findIndex(
    //     (x) => x.finished_good.commercial_bundle_item && x.finished_good.commercial_bundle_item.bundle_id === bundle.id,
    //   );
    //   return index >= 0;
      return this.item.commercial_skid_items.some(
        (x) => x.commercial_bundle?.id === bundle.id
      );
    },

    isFinishedGoodSameJob(finishedGood) {
      const firstItem = this.item.commercial_skid_items?.[0];

      const firstItemJob = firstItem?.finished_good?.commercial_schedule?.job ?? firstItem?.commercial_bundle?.job ?? null;

      const addedItemJob = finishedGood?.commercial_schedule?.job ?? null;

      const firstItemJobName = FormatHelpers.getJobName(firstItemJob);
      const addedItemJobName = FormatHelpers.getJobName(addedItemJob);

      const isSameJob = firstItemJob && addedItemJob ? firstItemJob.id === addedItemJob.id : true;

      return {
        is_same_job: isSameJob,
        first_item_job_name: firstItemJobName,
        added_item_job_name: addedItemJobName,
      };
    },

    isBundleSameJob(bundle) {
      const firstItem = this.item.commercial_skid_items?.[0];

      const firstItemJob = firstItem?.finished_good?.commercial_schedule?.job ?? firstItem?.commercial_bundle?.job ?? null;

      const addedItemJob = bundle?.job ?? null;

      const firstItemJobName = FormatHelpers.getJobName(firstItemJob);
      const addedItemJobName = FormatHelpers.getJobName(addedItemJob);

      const isSameJob = firstItemJob && addedItemJob ? firstItemJob.id === addedItemJob.id : true;

      return {
        is_same_job: isSameJob,
        first_item_job_name: firstItemJobName,
        added_item_job_name: addedItemJobName,
      };
    },

    async isTagAssignedToBundle(finishedGood) {
      const readModel = {
        filters: {
          finished_good_commercial_id: finishedGood.id,
        },
      };

      const res = await this.$api.commercialBundleItem.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].commercial_bundle?.bundle_number;
      }

      return null;
    },

    async isTagAssignedToSkid(finishedGood) {
      const readModel = {
        filters: {
          finished_good_commercial_id: finishedGood.id,
        },
      };

      const res = await this.$api.commercialSkidItem.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].commercial_skid?.skid_number;
      }

      return null;
    },

    async isBundleAssignedToSkid(bundle) {
      const readModel = {
        filters: {
          commercial_bundle_id: bundle.id,
        },
      };

      const res = await this.$api.commercialSkidItem.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].commercial_skid?.skid_number;
      }

      return null;
    },

    async isTagAssignedToBillOfLading(finishedGood) {
      const readModel = {
        filters: {
          finished_good_commercial_id: finishedGood.id,
        },
      };

      const res = await this.$api.commercialBillOfLading.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].id;
      }

      return null;
    },

    async isBundleAssignedToBillOfLading(bundle) {
      const readModel = {
        filters: {
          commercial_bundle_id: bundle.id,
        },
      };

      const res = await this.$api.commercialBillOfLadingItem.read(readModel);
      const cancelCode = 3001;
      if (res === cancelCode) return undefined;
      if (!res || !res.data) {
        return undefined;
      }

      if (res.total >= 1) {
        const firstIndex = 0;
        return res.data[firstIndex].commercial_bill_of_lading_id;
      }

      return null;
    },

    async removeItem(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to remove this record?',
      });
      if (!confirm) return;

      const itemIndex = this.item.commercial_skid_items.findIndex((x) => {
        if (
          item.type === 'finished_good_group' &&
          item.finished_goods &&
          item.finished_goods.length === 1 &&
          x.type === 'finished_good_group'
        ) {
          return x.finished_goods.some((fg) => fg.id === item.finished_goods[0].id);
        }

        if (item.finished_good && x.finished_good) {
          return x.finished_good.id === item.finished_good.id;
        }

        if (item.commercial_bundle && x.commercial_bundle) {
          return x.commercial_bundle.id === item.commercial_bundle.id;
        }

        return false;
      });

      if (itemIndex >= 0) {
        this.item.commercial_skid_items.splice(itemIndex, 1);
      }
    },

    getLengthFromFinishedGoodComponent(finishedGood) {
      if (
        !finishedGood ||
        (finishedGood.type_id !== this.finishedGoodCommercialTypeIdFrame && finishedGood.type_id !== this.finishedGoodCommercialTypeIdSlab)
      ) {
        return 0;
      }
      if (finishedGood.width != null) {
        return finishedGood.width;
      }
      if (finishedGood.height != null) {
        return finishedGood.height;
      }
    },

    getWeightKilograms(finishedGood) {
      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdFrame || finishedGood.type_id === this.finishedGoodCommercialTypeIdSlab) {
        // For frames, weight is calculated differently
        const length = this.getLengthFromFinishedGoodComponent(finishedGood);
        if (!length) return null;
        if (!finishedGood.aluminum_die || !finishedGood.aluminum_die.weight_ratio) return null;
        return length * finishedGood.aluminum_die.weight_ratio;
      }

      if (!finishedGood.sqft || !finishedGood.type.weight_ratio) return null;

      return finishedGood.sqft * finishedGood.type.weight_ratio;
    },

    getTotalSqft(finishedGoods) {
      return finishedGoods.reduce((acc, item) => acc + parseFloat(item.sqft ? item.sqft : 0), 0);
    },

    getTotalWidth(finishedGoods) {
      return finishedGoods.reduce((acc, item) => acc + parseFloat(item.width && item.type_id !== this.finishedGoodCommercialTypeIdFrame && item.type_id !== this.finishedGoodCommercialTypeIdSlab ? item.width : 0), 0);
    },

    getTotalHeight(finishedGoods) {
      return finishedGoods.reduce((acc, item) => acc + parseFloat(item.height && item.type_id !== this.finishedGoodCommercialTypeIdFrame && item.type_id !== this.finishedGoodCommercialTypeIdSlab ? item.height : 0), 0);
    },

    getTotalLength(finishedGoods){
      let totalLength = finishedGoods.reduce((acc, item) => {
        let accLength = acc;
        let itemLength = 0
        if (item.type_id == this.finishedGoodCommercialTypeIdFrame || item.type_id === this.finishedGoodCommercialTypeIdSlab) {
          itemLength = this.getLengthFromFinishedGoodComponent(item);
        }
        // acc + parseFloat(item.finished_good.height && item.finished_good.type_id == this.finishedGoodCommercialTypeIdFrame ? item.finished_good.height : 0)
        return accLength + itemLength;
      }, 0);
      return totalLength;
    },

    // getTotalWeightKilograms() {
    //   return this.item.bill_of_lading_items.reduce((acc, item) => acc + (parseFloat(item.finished_good.type.weight_ratio ? item.finished_good.type.weight_ratio : 0) * parseFloat(item.finished_good.sqft ? item.finished_good.sqft : 0)), 0);
    // },

    getTotalWeightKilograms(finishedGoods) {
      return finishedGoods.reduce((acc, item) => acc + (this.getWeightKilograms(item) || 0), 0);
    },

    // getAllTotalWeightKilograms() {
    //   let total = this.getTotalWeightKilograms();
    //   const extraItemsTotalWeight = this.$refs.billOfLadingExtraItemForm ? this.$refs.billOfLadingExtraItemForm.getTotalWeightKilograms() : 0;
    //   total += extraItemsTotalWeight;
    //   return total;
    // },

    // getAllTotalWeightPounds() {
    //   return this.getAllTotalWeightKilograms() * 2.20462;
    // },

    convertToFraction(decimal) {
      // check if  a decimal number has numbers after the decimal point
      const decimalString = decimal.toString();
      const decimalPointIndex = decimalString.indexOf('.');

      if (decimalPointIndex === -1) {
        return decimal;
      }
      //

      const fractions = {
        0.0625: '1/16',
        0.125: '1/8',
        0.1875: '3/16',
        0.25: '1/4',
        0.3125: '5/16',
        0.375: '3/8',
        0.4375: '7/16',
        0.5: '1/2',
        0.5625: '9/16',
        0.625: '5/8',
        0.6875: '11/16',
        0.75: '3/4',
        0.8125: '13/16',
        0.875: '7/8',
        0.9375: '15/16',
      };

      // If the decimal is an exact match to any fraction, return the fraction directly
      if (decimal in fractions) {
        return fractions[decimal];
      }

      const wholeNumber = Math.floor(decimal);
      // eslint-disable-next-line no-param-reassign
      decimal -= wholeNumber; // Remove the whole number part

      let closestFraction = Object.keys(fractions)[0];

      // eslint-disable-next-line no-restricted-syntax
      for (const fraction of Object.keys(fractions)) {
        if (
          Math.abs(decimal - fraction) < Math.abs(decimal - closestFraction)
        ) {
          closestFraction = fraction;
        }
      }

      if (wholeNumber > 0) {
        return `${wholeNumber} - ${fractions[closestFraction]}"`;
      }
      return fractions[closestFraction];
    },

    displayInchesWithFraction(inches) {
      // Convert height to the raw number with rounding
      const raw = Math.round(inches / 0.0625) * 0.0625;

      // Extract the whole number part
      const wholeNumber = Math.floor(raw);

      // Calculate the decimal part
      const decInput = parseFloat((raw - wholeNumber).toFixed(4));

      // Initialize numerator and denominator
      let numerator = 1;
      let denominator = 1;

      // Calculate the fraction
      let decimalFraction = numerator / denominator;
      while (decimalFraction !== decInput) {
        if (decimalFraction < decInput) {
          numerator += 1;
        } else {
          denominator += 1;
          numerator = Math.floor(decInput * denominator);
        }
        decimalFraction = numerator / denominator;
      }

      // Create the final output string
      let result = '';
      if (wholeNumber > 0) {
        result += `${wholeNumber}"`;
      }

      if (numerator > 0) {
        result += `-${numerator}/${denominator}''`;
      }

      return result;
    },

    convertDateFormat(inputDate) {
      // Parse the input date
      const date = new Date(inputDate);

      // Format the date as "YYYY-MM-DD h:mm a" (e.g., 2023-10-24 9:25 PM)
      const formattedDate = date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

      return formattedDate;
    },

    qrCodeValueChange() {
      if (!this.tagQr) return;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.handleTagScan();
      }, 700);
    },

    extractSequenceNumber(finishedGood) {
      const tagId = finishedGood?.tag_id;
      if (!tagId) return '-';

      const parts = tagId.split('-');
      return parts.length > 1 ? parts[parts.length - 1] : '-';
    },

    headlineText() {
      if (this.item.id) {
        return 'Update';
      }
      return 'Create';
    },

    submitBtnText() {
      if (this.item.id) {
        return 'Update';
      }
      return 'Submit';
    },

    isSubmitBtn() {
      if (this.isViewing) {
        return false;
      }
      return true;
    },

    extractIdFromQrCode(qrCode) {
      const match = qrCode.match(/^b(0*[^0]\d*)/i);
      return match ? match[1] : false;
    },

    onResize() {
      this.tableHeight = Math.floor((window.innerHeight)) - this.topSpaceHeight;
    },

    updateTableHeight() {
      this.tableHeight = Math.floor((window.innerHeight)) - this.topSpaceHeight;
    },

    toggleExpand(item) {
      if (!item) return;

      const index = this.getExpandedRowIndex(item);

      if (index > -1) {
        this.expandedItems.splice(index, 1);
      } else {
        this.expandRow(item);
      }
    },

    getExpandedRowIndex(item) {
      return this.expandedItems.findIndex(
        (expandedItem) => expandedItem && expandedItem.temp_id === item.temp_id
      );
    },

    isRowExpanded(item) {
      return this.getExpandedRowIndex(item) !== -1;
    },

    expandRow(item) {
      if (this.getExpandedRowIndex(item) === -1) {
        this.expandedItems.push(item);
      }
    },

    getType(commercialSkidItem) {
      if (commercialSkidItem.type === 'finished_good_group') return 'Finished Goods';
      if (commercialSkidItem.finished_good) return 'Finished Good';
      if (commercialSkidItem.commercial_bundle) return 'Bundle';
      return 'Unknown Type';
    },

    getNumberOrTag(commercialSkidItem) {
      if (commercialSkidItem.type === 'finished_good_group') {
        return commercialSkidItem.tag_number || '';
      }

      if (commercialSkidItem.finished_good) {
        return commercialSkidItem.finished_good.tag_id || 'Unknown Tag';
      }

      if (commercialSkidItem.commercial_bundle) {
        return commercialSkidItem.commercial_bundle.bundle_number || 'Unknown Bundle Number';
      }

      return 'Unknown Number/Tag';
    },

    getQuantity(commercialSkidItem) {
      if (commercialSkidItem.type === 'finished_good_group') {
        return commercialSkidItem.finished_goods.length;
      }

      if (commercialSkidItem.finished_good) return 1;

      if (commercialSkidItem.commercial_bundle) {
        return commercialSkidItem.commercial_bundle.commercial_bundle_items
          ? commercialSkidItem.commercial_bundle.commercial_bundle_items.length
          : 'Unknown Quantity';
      }

      return 'Unknown Quantity';
    },

    getWorkOrder(commercialSkidItem) {
      if (commercialSkidItem.finished_good !== undefined && commercialSkidItem.finished_good !== null) return commercialSkidItem.finished_good && commercialSkidItem.finished_good.work_order ? commercialSkidItem.finished_good.work_order : 'Unknown Work Order';
      if (commercialSkidItem.commercial_bundle !== undefined && commercialSkidItem.commercial_bundle !== null) return commercialSkidItem.commercial_bundle && commercialSkidItem.commercial_bundle.job && commercialSkidItem.commercial_bundle.job.code ? commercialSkidItem.commercial_bundle.job.code : 'Unknown Work Order';
      return 'Unknown Work Order';
    },

    getReference(commercialSkidItem) {
      if (commercialSkidItem.finished_good !== undefined && commercialSkidItem.finished_good !== null) return commercialSkidItem.finished_good && commercialSkidItem.finished_good.floor_number ? commercialSkidItem.finished_good.floor_number : 'Unknown Reference';
      if (commercialSkidItem.commercial_bundle !== undefined && commercialSkidItem.commercial_bundle !== null) return commercialSkidItem.commercial_bundle && commercialSkidItem.commercial_bundle.job && commercialSkidItem.commercial_bundle.job.reference ? commercialSkidItem.commercial_bundle.job.reference : 'Unknown Reference';
      return 'Unknown Reference';
    },

    getSkidItemWeight(commercialSkidItem) {
      const finishedGoods = this.getFinishedGoodOrBundleFinishedGoods(commercialSkidItem);
      const weight = this.getTotalWeightKilograms(finishedGoods);

      return parseFloat(weight).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },

    getFinishedGoodOrBundleFinishedGoods(commercialSkidItem) {
      if (commercialSkidItem.type === 'finished_good_group') {
        return commercialSkidItem.finished_goods || [];
      }

      if (commercialSkidItem.finished_good) {
        return [commercialSkidItem.finished_good];
      }

      if (commercialSkidItem.commercial_bundle) {
        const commercialBundleItems =
          commercialSkidItem.commercial_bundle.commercial_bundle_items || [];

        return commercialBundleItems
          .filter((item) => item.finished_good)
          .map((item) => item.finished_good);
      }

      return [];
    },

    getFinishedGoodTagId(finishedGood) {
      return finishedGood && finishedGood.tag_id ? finishedGood.tag_id : '-';
    },

    getFinishedGoodTagNumber(finishedGood) {
      return finishedGood && finishedGood.tag_number ? finishedGood.tag_number : '-';
    },

    getFinishedGoodTypeName(finishedGood) {
      return finishedGood && finishedGood.type && finishedGood.type.name ? finishedGood.type.name : '-';
    },

    getFinishedGoodSequenceNumber(finishedGood) {
      return this.extractSequenceNumber(finishedGood);
    },

    getFinishedGoodAluminumDieCode(finishedGood) {
      return finishedGood && finishedGood.aluminum_die && finishedGood.aluminum_die.code ? finishedGood.aluminum_die.code : '-';
    },

    getFinishedGoodIntColorCode(finishedGood) {
      return finishedGood && finishedGood.int_color && finishedGood.int_color.code ? finishedGood.int_color.code : '-';
    },

    getFinishedGoodExtColorCode(finishedGood) {
      return finishedGood && finishedGood.ext_color && finishedGood.ext_color.code ? finishedGood.ext_color.code : '-';
    },

    hasFinishedGoodStatus(finishedGood) {
      return finishedGood && finishedGood.status ? true : false;
    },

    getFinishedGoodStatusColor(finishedGood) {
      return finishedGood && finishedGood.status ? finishedGood.status.color : '#000000';
    },

    getFinishedGoodStatusName(finishedGood) {
      return finishedGood && finishedGood.status ? finishedGood.status.name : '';
    },

    getFinishedGoodSqft(finishedGood) {
      return finishedGood && finishedGood.sqft ? `${finishedGood.sqft.toFixed(2)} sqft` : '-';
    },

    getFinishedGoodWidth(finishedGood) {
      return finishedGood && finishedGood.type_id !== this.finishedGoodCommercialTypeIdFrame && finishedGood.type_id !== this.finishedGoodCommercialTypeIdSlab && finishedGood.width ? this.displayInchesWithFraction(finishedGood.width) : '-';
    },

    getFinishedGoodHeight(finishedGood) {
      return finishedGood && finishedGood.type_id !== this.finishedGoodCommercialTypeIdFrame && finishedGood.type_id !== this.finishedGoodCommercialTypeIdSlab && finishedGood.height ? this.displayInchesWithFraction(finishedGood.height) : '-';
    },

    getFinishedGoodLength(finishedGood) {
      if (!finishedGood) return '-';

      const isValidType =
        finishedGood.type_id === this.finishedGoodCommercialTypeIdFrame ||
        finishedGood.type_id === this.finishedGoodCommercialTypeIdSlab;

      if (!isValidType) return '-';

      const length = this.getLengthFromFinishedGoodComponent(finishedGood);

      return this.displayInchesWithFraction(length);
    },

    getFinishedGoodWeight(finishedGood) {
      if (!finishedGood) return 'Unable to Calculate Weight';
      if (!finishedGood.type) return 'Unable to Calculate Weight';

      const weight = this.getWeightKilograms(finishedGood);

      return weight ? parseFloat(weight.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })) : 'Unable to Calculate Weight';
    },

    getTotalBundleQuantity() {
      // get all the commercial_skid_items where commercial_bundle_id is not null
      const bundleItems = this.item.commercial_skid_items.filter(item => (item.commercial_bundle_id || item.commercial_bundle));
      return bundleItems.length;
    },

    getTotalFinishedGoodQuantity() {
      if (!this.item || !this.item.commercial_skid_items) return 0;
      let total = 0;

      this.item.commercial_skid_items.forEach((item) => {
        if (item.type === 'finished_good_group') {
          total += item.finished_goods
            ? item.finished_goods.length
            : 0;

          return;
        }

        if (item.commercial_bundle_id > 0 || item.commercial_bundle) {
          if (
            item.commercial_bundle &&
            item.commercial_bundle.commercial_bundle_items
          ) {
            item.commercial_bundle.commercial_bundle_items.forEach((bundleItem) => {
              if (bundleItem.finished_good) {
                total += 1;
              }
            });
          }
        }
        else if (item.finished_good_id > 0 || item.finished_good) {
          total += 1;
        }
      });
      return total;
    },

    getTopLevelRowClass(commercialSkidItem) {
      if (commercialSkidItem.commercial_bundle_id > 0 || commercialSkidItem.commercial_bundle) {
        return 'commercial-skid-row-bundle';
      }

      if (commercialSkidItem.finished_good_id > 0 || commercialSkidItem.finished_good) {
        return 'commercial-skid-row-finished-good';
      }

      if (commercialSkidItem.type === 'finished_good_group') {
        return 'commercial-skid-row-finished-good';
      }

      return '';
    },

    getFinishedGoodRowClass() {
      return 'commercial-skid-row-finished-good';
    },

    getTopLevelFinishedGoodGroup() {
      return this.item.commercial_skid_items.find(
        (item) => item.type === 'finished_good_group'
      );
    },

    groupTopLevelFinishedGoods(commercialSkidItems) {
      const groupedItems = [];
      const finishedGoodGroup = {
        type: 'finished_good_group',
        tag_number: '-',
        finished_goods: [],
        temp_id: 'top-level-finished-goods',
      };
      let hasFinishedGoodGroup = false;

      commercialSkidItems.forEach((item) => {
        if (item.type === 'finished_good_group') {
          if (!hasFinishedGoodGroup) {
            groupedItems.push(finishedGoodGroup);
            hasFinishedGoodGroup = true;
          }

          finishedGoodGroup.finished_goods.push(...(item.finished_goods || []));
          return;
        }

        if (item.finished_good) {
          if (!hasFinishedGoodGroup) {
            groupedItems.push(finishedGoodGroup);
            hasFinishedGoodGroup = true;
          }

          finishedGoodGroup.finished_goods.push({
            ...item.finished_good,
            commercial_skid_item_id: item.id,
          });
          return;
        }

        groupedItems.push({
          ...item,
          temp_id: item.id || Date.now(),
        });
      });

      return groupedItems;
    },

    flattenCommercialSkidItems() {
      const flattenedItems = [];

      this.item.commercial_skid_items.forEach((item) => {
        if (item.type === 'finished_good_group') {
          item.finished_goods.forEach((finishedGood) => {
            flattenedItems.push({
              id: finishedGood.commercial_skid_item_id,
              finished_good: finishedGood,
            });
          });
          return;
        }

        flattenedItems.push(item);
      });

      return flattenedItems;
    },

    showTopLevelRemoveButton(item) {
      if (item.type === 'finished_good_group') {
        return item.finished_goods.length <= 1;
      }

      return true;
    },

    showFinishedGoodRemoveButton(finishedGood) {
      return this.item.commercial_skid_items.some((skidItem) =>
        skidItem.type === 'finished_good_group' &&
        skidItem.finished_goods.length > 1 &&
        skidItem.finished_goods.some((fg) => fg.id === finishedGood.id)
      );
    },

    async removeFinishedGoodFromGroup(finishedGood) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to remove this finished good?',
      });

      if (!confirm) return;

      const group = this.item.commercial_skid_items.find((skidItem) =>
        skidItem.type === 'finished_good_group' &&
        skidItem.finished_goods.some((fg) => fg.id === finishedGood.id)
      );

      if (!group) return;

      const finishedGoodIndex = group.finished_goods.findIndex(
        (fg) => fg.id === finishedGood.id
      );

      if (finishedGoodIndex >= 0) {
        group.finished_goods.splice(finishedGoodIndex, 1);
      }

      if (group.finished_goods.length === 0) {
        const groupIndex = this.item.commercial_skid_items.findIndex(
          (skidItem) => skidItem.temp_id === group.temp_id
        );

        if (groupIndex >= 0) {
          this.item.commercial_skid_items.splice(groupIndex, 1);
        }
      }
    },

    getFinishedGoodMissingField(finishedGood) {
      if (!finishedGood) return null;

      if (finishedGood.type_id === this.finishedGoodCommercialTypeIdWindow || finishedGood.type_id === this.finishedGoodCommercialTypeIdDoor) return 'sqft';

      if (
        (finishedGood.type_id === this.finishedGoodCommercialTypeIdFrame ||
          finishedGood.type_id === this.finishedGoodCommercialTypeIdSlab) 
      ) {
        console.log('finishedGood in getFinishedGoodMissingField: ', finishedGood);
        if (!this.getLengthFromFinishedGoodComponent(finishedGood)) return 'length';
        console.log('finishedGood aluminum die in getFinishedGoodMissingField: ', finishedGood.aluminum_die);
        console.log('finishedGood aluminum die weight ratio in getFinishedGoodMissingField: ', finishedGood.aluminum_die ? finishedGood.aluminum_die.weight_ratio : 'no aluminum die');
        if (!finishedGood.aluminum_die) return 'aluminum die';
        if (!finishedGood.aluminum_die.weight_ratio) return 'aluminum die weight ratio';
      }

      return 'field';
    },
  }
};
</script>
<style scoped>
::v-deep
  #sub-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
    background-color: #5f5f5f;
  }
::v-deep .commercial-skid-row-bundle {
  background-color: #fffbd7 !important;
}

::v-deep .commercial-skid-row-finished-good {
  background-color: #dbefdc !important;
}
</style>
